import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { rpcClient } from 'src/api/rpc/client';

export function useTaskComments(taskId: string) {
  return useQuery({
    queryKey: ['task-comments', taskId],
    queryFn: () =>
      rpcClient.comments.list({
        commentableType: 'TASK',
        commentableId: taskId,
        limit: 200,
        offset: 0,
      }),
    refetchInterval: 10_000,
  });
}

export function useCreateTaskComment(taskId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: string) =>
      rpcClient.comments.create({
        commentableType: 'TASK',
        commentableId: taskId,
        body,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['task-comments', taskId] });
    },
  });
}
